export const auth0Config = {
    domain: "vzd.eu.auth0.com",
    clientId: "1vGDLUipVJtgWoAFhl1RffCQJh2VbdUQ",
    redirectUri: window.location.origin,  // Redirect to your app after login
    audience: "http://localhost:3000",  // Optional, for APIs
  };